import React from 'react';
import { Link } from 'react-router-dom';
import { projectsData } from './Portfolio/Projects';

const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

/* Dates in projectsData are written "2025-6-10", which Date parses as UTC and
 * can shift back a day in local time. Read the parts directly instead. */
const formatDate = (date) => {
    const [year, month] = date.split('-');
    return `${MONTHS[Number(month) - 1]} ${year}`;
};

/* Featured work first, then everything else newest-first. */
const ordered = [...projectsData].sort((a, b) => {
    if (a.featured !== b.featured) return a.featured ? -1 : 1;
    return new Date(b.date) - new Date(a.date);
});

const Portfolio = () => {
    return (
        <>
            <p className="section-heading">
                <strong>Projects</strong>
            </p>

            {ordered.map((project) => (
                <p className="paper-entry" key={project.id}>
                    <Link to={`/projects/${project.id}`} state={{ project }}>
                        {project.title}
                    </Link>
                    <br />
                    <span className="authors">
                        {project.summary}
                        <br />
                        {formatDate(project.date)}
                        <br />
                        <span className="tags">{project.tags.join(' · ')}</span>
                    </span>
                </p>
            ))}
        </>
    );
};

export default Portfolio;
